// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBBtn, MDBCol } from 'mdbreact';

const ControlButtons = ({
  currentWorkOrder, setShowAddReportIssue, showAddReportIssue,
}) => (
  <MDBCol style={{ textAlign: 'end' }}>
    {
      !showAddReportIssue
        ? (
          <button
            color="deep-orange"
            className="standard_btn lightest_btn"
            onClick={() => setShowAddReportIssue(true)}
          >
            {`Report ${currentWorkOrder?.report_issue_details?.length > 0 ? 'another' : 'an'} issue`}
          </button>
        )
        : <></>
    }
  </MDBCol>
);

export default ControlButtons;
